interface SidebarSectionProps {
  label: string
  collapsed?: boolean
  children: React.ReactNode
}

export function SidebarSection({ label, collapsed, children }: SidebarSectionProps) {
  if (collapsed) {
    return (
      <>
        <div className="w-8 mx-auto border-t border-white/[0.08] my-2" />
        {children}
      </>
    )
  }

  return (
    <div className="mt-4">
      <div className="px-3 mb-1 text-[9px] uppercase tracking-[1.5px] text-white/25 font-semibold">
        {label}
      </div>
      <div className="flex flex-col gap-0.5">
        {children}
      </div>
    </div>
  )
}
